"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2899],{

/***/ 56116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ConfettiComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _reonomy_react_confetti_explosion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80011);
/* harmony import */ var _reonomy_react_confetti_explosion__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_reonomy_react_confetti_explosion__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var DURATION = 4000;
var ConfettiComponent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo(function(param) {
    var show = param.show, setShow = param.setShow;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (show) {
            setTimeout(function() {
                return setShow(false);
            }, DURATION - 500);
        }
    }, [
        show,
        setShow
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("absolute inset-0 z-0 center", {
            hidden: !show
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_reonomy_react_confetti_explosion__WEBPACK_IMPORTED_MODULE_1___default()), {
            colors: [
                "#fff",
                "#555555",
                "#636363"
            ],
            force: 0.5,
            duration: DURATION,
            particleCount: 150,
            floorHeight: 1200,
            floorWidth: 1200
        })
    });
});


/***/ }),

/***/ 26165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ AppReviewsContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./reviews-data.json
var reviews_data_namespaceObject = JSON.parse('{"A":[{"title":"What you need","author":"Jimmy V","review_date":"Dec 22","review":"You think you only have 25-40 minute daily for your health/exercise? That is not a problem. <b>You will have everything you need with this app. From timing every workout to having videos and a chat with the coaches. No gear? No problem.</b> Suit yourself for an amazing experience."},{"title":"Best coaching around","author":"Reyez042287","review_date":"Dec 21","review":"I\'ve been working out for over 13 years and tried everything from personal trainers, crossfit, etc. <b>This programming has changed my life. I’m stronger and able to lift heavier then I ever have and working out 6 days a week. My body alone has changed for the better in just the 2 short months i’ve been a member.</b> And this team. let me tell you about this team that builds you up, challenges you daily and holds you accountable. "},{"title":"Amazing Workout Platform","author":"Mdubb57","review_date":"Dec 20","review":"The vibe and energy on the Ladders platform is unlike any other. <b>I used to search to find strength workouts ahead of my workouts and try to mix and match body parts and splits. It\'s all taken care of for me thru the App. No thinking. Just work.</b> Not always in the mood for it but Bobby and Joe push you thru it and you happy when it\'s over!"},{"title":"Elevate is Great!","author":"Annie4273","review_date":"Nov 30","review":"I joined Coach Elise\'s elevate team on Ladder and love the motivation and intention in her workouts and among the team members. The workouts are generally :0-40 minutes and they fly by thanks to Elise\'s pace and style of switching things up. <b>I feel stronger already and look forward to the workouts every day!</b>"},{"title":"This program checked all the boxes for me.","author":"JB140.6","review_date":"Nov 15","review":"✅ Structured Workouts ✅ Coached Sessions ✅ Workout from home ✅ Flexibility ✅ Accountability. Having coached workout sessions delivered every Sunday evening for the upcoming week is a lifesaver! <b>Knowing my week is already planned allows me to stay focused and on track with my fitness goals.</b>"},{"title":"Do Body and Bell","author":"DarcyDP","review_date":"Nov 14","review":"The workouts are extremely fun and motivating. I can\'t wait to login and see my workouts each day. <b>Lauren is a great coach. She is smart, funny, raw, and unfiltered. It is well thought out programming at its best.</b> She builds on what you have learned while keeping it fresh and engaging. I would highly recommend."},{"title":"Alpha Wolfpack","author":"mattyb5702","review_date":"Nov 11","review":"Great personal training app for those with hectic schedules and no time to plan their own training sessions. <b>Literally start the app and push ‘Start Workout\' and you are being led through a training plan with tangible goal posts and noticeable strength increases.</b> Highly recommend for time constrained athletes!"},{"title":"For Athletes!","author":"Cashashworth","review_date":"Oct 29","review":"<b>Best training I\'ve had since college athletics. If you\'re looking for fun and functional workouts that will push you, start with Body+Bell on the Ladder App.</b> Coach Lauren is incredibly knowledgeable w/ no frills (in the best way possible). My best app investment ever."},{"title":"Best training \'app\', hands down","author":"wbdenks","review_date":"Oct 29","review":"Calling this an \'app\' undersells what it truly is: <b>a gateway to amazing trainers (Lauren Kanski in particular!) and team members, with ever changing programming, and a ton of support to keep you motivated.</b> I\'m 50 days in, and have worked out 48 of them - not just because I want my \'badge\' (I do), but because I look forward to the workouts."},{"title":"Team Crews Control","author":"Pr2rcan","review_date":"Oct 28","review":"<b>This app is amazing and my coach and team are even more amazing. Coach Andre has built an incredible program that\'s easy to follow, with clear coaching. The work outs are very challenging but do not be intimidated by them.</b> Coach Andre will help you modify your work outs according to your fitness level and knowledge. "},{"title":"Exceeded expectations!","author":"aàv","review_date":"Oct 22","review":"I\'ve been using the ladder app for a little over 2 months now and it has exceeded my expectations in every way. <b>From the unique programming, coach engagement, the ladder community, it is one of the best fitness apps I\'ve tried.</b> Will be sticking with this plan for a while. Love the progress so far!"},{"title":"Great app for home workouts!","author":"cannan138","review_date":"Oct 12","review":"I signed up with Team Maximus. The app works great. <b>Coaches set up the daily routine, client hits go!</b> Ofers a great way to communicate with team coaches and other members. Plus, it integrates well with Apple Music to keep your playlist going."},{"title":"Love #TeamBoundless","author":"Sodonne4","review_date":"Oct 7","review":"Tried the free week trial and was hooked. <b>Unbelievable value. You get new weekly workouts, coach videos, coaching and suggestions during the workouts, and chat support with your team and coaches.</b> I thought I was in decent shape, but these workouts are a whole new kind of challenge. Absolutely love it!"},{"title":"The End All Of All Apps","author":"Johnatlanticism","review_date":"Jun 28","review":"I\'ve been working out religiously for 10+ years. Always circuit training. <b>I\'ve used a lot of sites and apps, trust me. This one is hands down the best. My search for THE App is over. The layout is clean, a fresh week of workouts every Sunday night. You can\'t beat it. You just can\'t.</b> So many different teams and coaches to go with your style, you can\'t go wrong. It\'s worth the price. I\'m a member for life."},{"title":"The best workout app out there!","author":"TJ1TJ2TJ3","review_date":"Feb 11","review":"Fantastic workout app. <b>Fresh new workouts every week - 7 days a week! Super convenient as you can get a workout in on your own schedule which has helped me get in a workout in every day</b> vs. relying on getting out to a physical gym, which wasn\'t happening 7 days a week. Highly recommend this app!"},{"title":"Climb with me","author":"eormada","review_date":"Jan 26","review":"Wow! Can I just say how awesome Andre is?! He makes you feel comfortable no matter what skill level you are. Good explanations and there is always a modification. <b>I went from a few times a week to working out everyday. The workouts are varied and never a dull day.</b> Also they are fast. Like around 30 minutes each. Been very happy and am seeing results."}]}');
// EXTERNAL MODULE: ./node_modules/react-snaplist-carousel/dist/index.es.js
var index_es = __webpack_require__(97905);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
;// CONCATENATED MODULE: ./components/home/app-reviews-container/index.js






var AppReviewsContainer = function() {
    var snapList = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-16 lg:pb-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* SnapList */.fZ, {
            direction: "horizontal",
            className: "pl-6 space-x-3 lg:space-x-8 overscroll-x-contain",
            ref: snapList,
            children: reviews_data_namespaceObject.A.map(function(param, i) {
                var title = param.title, _stars = param.stars, stars = _stars === void 0 ? 5 : _stars, review_date = param.review_date, author = param.author, review = param.review;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* SnapItem */.zd, {
                    snapAlign: "center",
                    className: "flex flex-col w-11/12 p-4 space-y-4 rounded-lg md:w-1/2 lg:w-1/3 bg-neutral-800",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "font-extrabold tracking-wide text-white font-display",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex space-x-2",
                                            children: (0,_to_consumable_array/* default */.Z)(new Array(stars)).map(function(_, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* StarIcon */.r7p, {
                                                    className: "w-5 h-5 text-volt"
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-white",
                                            children: review_date
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-white",
                                            children: author
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                color: "#BCBCBC"
                            },
                            className: "block text-opacity-50 review-details",
                            dangerouslySetInnerHTML: {
                                __html: review
                            }
                        })
                    ]
                }, i);
            })
        })
    });
};


/***/ }),

/***/ 99312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CoachContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63801);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5276);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43337);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89211);








var Item = function(param) {
    var i = param.i, lastItem = param.lastItem, onEnter = param.onEnter, onLeave = param.onLeave, handleLastVisible = param.handleLastVisible;
    var ref = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
        threshold: 0.5,
        onEnter: function(param) {
            var unobserve = param.unobserve;
            // onEnter(i)
            if (lastItem === i) {
                unobserve();
                handleLastVisible();
            }
        },
        onLeave: function() {
        // onLeave(i)
        }
    }), observe = ref.observe, inView = ref.inView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: observe,
        alt: "ladder coach ".concat(i),
        className: "w-1/2 md:w-1/3 xl:w-1/4",
        src: "https://media.teams.joinladder.com/website/coaches/portraits/".concat(i, ".png")
    });
};
var ScrollingCoaches = function(param) {
    var _initialItems = param.initialItems, initialItems = _initialItems === void 0 ? [
        0,
        1,
        2,
        3,
        4
    ] : _initialItems, _speed = param.speed, speed = _speed === void 0 ? 0.1 : _speed, inView = param.inView;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), shouldScroll = ref[0], setShouldScroll = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialItems), items = ref1[0], setItems = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), x = ref2[0], setX = ref2[1];
    (0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        setX(function(current) {
            return current + speed;
        });
    }, inView && shouldScroll ? 0.1 : null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.div */ .E.div, {
        initial: {
            x: 0
        },
        animate: {
            x: -x
        },
        className: "flex space-x-3 transform scrollbars-hidden overscroll-x-contain scroll-pl-3 first:pl-3 last:pr-3 lg:space-x-6",
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                lastItem: items[items.length - 1],
                i: item,
                handleLastVisible: function() {
                    setItems(function(c) {
                        if (c.length === initialItems.length * 3) {
                            setShouldScroll(false);
                            return c;
                        }
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(c).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(initialItems));
                    });
                }
            }, i);
        })
    });
};
var CoachContainer = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(true), 2), playing = ref[0], togglePlaying = ref[1];
    var ref1 = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
        threshold: 0
    }), observe = ref1.observe, inView = ref1.inView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative z-10 min-h-screen pt-16 pb-32 lg:pb-56",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    background: "radial-gradient(50% 50% at 50% 50%, #403C56 28.65%, rgba(64, 60, 86, 0) 100%)"
                },
                className: "absolute inset-0 transform scale-110 -translate-y-24 rounded-full"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative mb-12",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl px-2 mx-auto space-y-6 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "hidden text-4xl text-center text-white lg:block lg:text-6xl heading",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "block mb-2 text-2xl lg:mb-4 lg:text-4xl",
                                    children: "ONLY THE"
                                }),
                                " ",
                                "BEST STRENGTH COACHES"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "block text-3xl text-center text-white lg:hidden heading",
                            children: "ONLY THE BEST STRENGTH COACHES"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-24 overflow-hidden max-w-screen",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.div */ .E.div, {
                        ref: observe,
                        className: "relative space-y-3 lg:space-y-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollingCoaches, {
                                initialItems: [
                                    15,
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    6
                                ],
                                inView: inView && playing
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollingCoaches, {
                                inView: inView && playing,
                                initialItems: [
                                    8,
                                    9,
                                    10,
                                    11,
                                    12,
                                    13,
                                    14
                                ],
                                speed: 0.175
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex items-center justify-end px-4 mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            "aria-label": playing ? "pause" : "play",
                            className: "p-4",
                            onClick: togglePlaying,
                            children: playing ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .PauseIcon */ .fpf, {
                                className: "w-8 h-8 text-white lg:w-12 lg:h-12"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .PlayIcon */ .o1U, {
                                className: "w-8 h-8 text-white lg:w-12 lg:h-12"
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 23572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ EachDaySection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-scrollmagic/dist/index.es.js
var index_es = __webpack_require__(44729);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/text-node/index.js
var text_node = __webpack_require__(12284);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 2 modules
var useWindowSize = __webpack_require__(90870);
// EXTERNAL MODULE: ./lib/use-breakpoint.js
var use_breakpoint = __webpack_require__(93335);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./components/home/every-day-section/days.js



var DaysComponent = function(param) {
    var progress = param.progress;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex space-x-3 lg:space-x-6",
        children: [
            "M",
            "T",
            "W",
            "T",
            "F",
            "S",
            "S"
        ].map(function(day, i) {
            // progress is a number between 0 and 1
            // we want to tell whether the progress is greater than the current day
            var isActive = progress > i / 7;
            var isNext = progress + 0.13 > i / 7;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("flex items-center border lg:text-base text-sm justify-center w-8 h-8 lg:w-10 lg:h-10 rounded-full cursor-default", {
                    "bg-charcoal text-white": !isActive,
                    "bg-volt text-black p-2 border-volt": isActive,
                    "border-volt": isNext || isActive,
                    "border-charcoal": !isNext && !isActive
                }),
                children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CheckIcon */.nQG, {
                    className: "w-6 h-6 lg:w-8 lg:h-8"
                }) : day
            }, i);
        })
    });
};

// EXTERNAL MODULE: ./components/action.js
var action = __webpack_require__(1191);
;// CONCATENATED MODULE: ./components/home/every-day-section/mobile.js






var EachDaySectionMobile = function(param) {
    var progress = param.progress;
    var breakpoint = (0,use_breakpoint/* useBreakpoint */.Gc)();
    var ref = (0,useWindowSize/* default */.Z)(), windowWidth = ref.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        // style={{ height: `calc(100vh - 250px)` }}
        className: "container flex flex-col items-center justify-center w-full px-4 pb-48 mx-auto lg:h-screen lg:pb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-0 flex items-end justify-center w-full h-full"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "relative z-10 mx-auto",
                            src: "https://media.teams.joinladder.com/website/phone/mobile/in-ring.png",
                            alt: "ladder app on an iPhone"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DaysComponent, {
                        progress: progress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-8 text-3xl text-center text-white heading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                            at: "home.eachDay.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "px-8 mt-4 text-center text-secondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                            at: "home.eachDay.description"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* Action */.a, {
                        at: "home.eachDay.cta",
                        event: {
                            action: "find_my_plan_cta_clicked"
                        },
                        className: "px-10 py-4 mt-10 text-black rounded-full cta bg-volt"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-cool-inview/dist/index.esm.js
var index_esm = __webpack_require__(5276);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/ring/w-phone.js




var WithPhone = function(_param) {
    var radius = _param.radius, stroke = _param.stroke, progress = _param.progress, props = (0,_object_without_properties/* default */.Z)(_param, [
        "radius",
        "stroke",
        "progress"
    ]);
    var normalizedRadius = radius - stroke * 2;
    var circumference = normalizedRadius * 2 * Math.PI;
    var strokeDashoffset = circumference - progress / 100 * circumference;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: radius * 2,
        width: radius * 2
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "f1",
                    x: "-50%",
                    y: "-40%",
                    width: "150%",
                    height: "150%",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            result: "offsetblur",
                            in: "offOut",
                            type: "matrix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            in: "SourceAlpha",
                            stdDeviation: "7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            in: "SourceAlpha",
                            stdDeviation: "7",
                            result: "blur"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            in: "blur",
                            dx: "3",
                            dy: "3",
                            result: "offsetBlur",
                            stdDeviation: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodColor: "#E6FF00",
                            floodOpacity: "2",
                            result: "offsetColor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in: "offsetColor",
                            in2: "offsetBlur",
                            operator: "in",
                            result: "offsetBlur"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("feMerge", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {
                                    in: "SourceGraphic"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feMergeNode", {
                                    in: "SourceGraphic"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                stroke: "#E6FF00",
                fill: "transparent",
                strokeWidth: stroke,
                strokeDasharray: circumference + " " + circumference,
                // style={{ strokeDashoffset, filter: "url(#f1)" }}
                style: {
                    strokeDashoffset: strokeDashoffset
                },
                r: normalizedRadius,
                cx: radius,
                cy: radius
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/confetti.js
var confetti = __webpack_require__(56116);
;// CONCATENATED MODULE: ./components/home/every-day-section/desktop.js









var EachDaySectionDesktop = function(param) {
    var progress = param.progress, isComplete = param.isComplete, setIsComplete = param.setIsComplete;
    var ref = (0,index_esm/* default */.ZP)({
        threshold: 0,
        onLeave: function(param) {
            var scrollDixrection = param.scrollDixrection, entry = param.entry, observe = param.observe, unobserve = param.unobserve;
            // Triggered when the target leaves the viewport
            if (scrollDirection.vertical === "up") {
                observe;
            }
        }
    }), observe = ref.observe, unobserve = ref.unobserve, inView = ref.inView, scrollDirection = ref.scrollDirection, entry = ref.entry;
    var breakpoint = (0,use_breakpoint/* useBreakpoint */.Gc)();
    var ref1 = (0,useWindowSize/* default */.Z)(), windowWidth = ref1.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            // style={{ height: `calc(100vh - 250px)` }}
            className: "flex flex-col items-center justify-center w-full h-screen px-12 mx-auto max-w-screen-2xl lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full space-y-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DaysComponent, {
                            progress: progress
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-5xl leading-tight text-left text-white heading lg:pr-28",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                                at: "home.eachDay.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xl text-left text-secondary lg:max-w-sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                                at: "home.eachDay.description"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* Action */.a, {
                            at: "home.eachDay.cta",
                            event: {
                                action: "find_my_plan_cta_clicked"
                            },
                            className: "px-10 py-4 text-black rounded-full cta bg-volt"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: observe,
                    className: "relative w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute inset-0 flex items-end justify-center w-full h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(confetti/* ConfettiComponent */.w, {
                                        show: isComplete,
                                        setShow: setIsComplete
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WithPhone, {
                                        radius: breakpoint === "sm" ? windowWidth / 2 - 20 : 250,
                                        stroke: breakpoint === "sm" ? 14 : 18,
                                        progress: progress * 100,
                                        className: "relative mx-auto scale-110 -rotate-45 top-4 md:top-6"
                                    }, breakpoint)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                style: {
                                    padding: "0 55px"
                                },
                                className: "relative z-10 mx-auto",
                                src: "https://media.teams.joinladder.com/website/phone/in-ring-lg.png",
                                alt: "ladder app on an iPhone"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/home/every-day-section/index.js







var EachDaySection = function() {
    var breakpoint = (0,use_breakpoint/* useBreakpoint */.Gc)();
    var ref = (0,react.useState)(false), isComplete = ref[0], setIsComplete = ref[1];
    var ref1 = (0,react.useState)(false), hasCompletedExplosionComplete = ref1[0], setHasCompletedExplosionComplete = ref1[1];
    var isMobile = (0,use_breakpoint/* useIsMobile */.dD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Controller */.Q, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Scene */.x, {
                    triggerHook: isMobile ? 0.5 : 0,
                    duration: 600,
                    pin: !isMobile,
                    children: function(progress) {
                        if (progress > 0.85 && !hasCompletedExplosionComplete) {
                            setIsComplete(true);
                            setHasCompletedExplosionComplete(true);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)({
                                        hidden: [
                                            "sm",
                                            "md"
                                        ].includes(breakpoint)
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EachDaySectionDesktop, {
                                        progress: progress,
                                        isComplete: isComplete,
                                        setIsComplete: setIsComplete
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)({
                                        hidden: ![
                                            "sm",
                                            "md"
                                        ].includes(breakpoint)
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EachDaySectionMobile, {
                                        progress: progress,
                                        isComplete: isComplete,
                                        setIsComplete: setIsComplete
                                    })
                                })
                            ]
                        });
                    }
                })
            })
        })
    });
};


/***/ }),

/***/ 99141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HZ": function() { return /* binding */ AnimateHeight; },
  "uw": function() { return /* binding */ FaqContainer; },
  "x1": function() { return /* binding */ renderItem; }
});

// UNUSED EXPORTS: Accordion, getAutoHeightDuration

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/text-node/index.js
var text_node = __webpack_require__(12284);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 116 modules
var motion = __webpack_require__(72986);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./faq-data.json
var faq_data_namespaceObject = JSON.parse('[{"title":"What is Ladder?","details":["Ladder gives you a strength training plan that fits into your schedule, every single day.","Through the Ladder app, members have access to professionally designed training programs and daily coach-prescribed workouts that are new each week and eliminate the wasted time, energy and money that comes with maintaining a balanced training routine.","With easy-to-follow video demonstrations, in-ear coaching, and precise pacing for every movement, Ladder delivers a workout experience that’s comparable to personal training but on your schedule, from wherever you workout, and at a fraction of the cost."]},{"title":"How is Ladder different from other fitness apps? ","details":["Ladder is built for strength training and specifically for busy people who are already motivated to workout.","This isn’t just a library of random workout content. Ladder gives you a complete workout plan to help you maximize your workouts and achieve real results.","With Ladder you’ll know exactly what workout to do, with a daily workout plan that’s programmed by an expert coach and new each week.","With Ladder, you get:",["✓ Results in less time","✓ New workouts every week","✓ A training plan that’s always with you","✓ Real coaching"],"The Ladder app is built specifically for progressive strength training, with in-ear coaching, video demonstrations and precise pacing built-in.","And Ladder doesn’t force its own music into your workouts.","The Ladder app works seamlessly with Spotify and Apple Music to integrate your playlists into your workout experience -  complete with volume control that automatically lowers the volume of your music when your coach is speaking and raises it when you’re working hardest."]},{"title":"Is Ladder for people who work out at home or at the gym? ","details":["Ladder members work out at home, at the gym, outside, or across all three. With Ladder your workout programming is in your pocket and ready when you are."]},{"id":"cc","title":"Do I need to give a credit card to start a trial?","details":["Nope! Ladder offers a 7 day, completely free test drive.","Ladder will not ask for a credit card to start a trial. No payment info is collected until AFTER the free trial ends."]},{"id":"cost","title":"How much does Ladder cost after my trial? ","details":["Ladder offers two membership plans that lets you choose based on the features you care about most.","The PRO Plan costs $29.99 per month and is billed as a monthly subscription.  This is for people looking for planned workout programming.","The ELITE Plan costs $44.99 per month and is billed as a monthly subscription. This is for people looking for planned workout programming and 1-on-1 help from their coach.","You can learn more about Ladder membership options on our <a href=\'/pricing\'>Pricing Page</a>."]},{"title":"How do I know which training plan or coach is right for me? ","details":["Ladder features some of the best strength coaches in the world, each offering unique coaching and training styles.","Take the Ladder matching quiz to receive a personalized recommendation based on your training goals and preferred training styles. Then try any (or all!) of our training teams completely free during your 7 day trial.","After you join, if your goals change or you\'re looking to switch it up, you can change your coach/plan up to 1x per month with both the PRO and ELITE Plans or if you upgrade with + you can change whenever you\'d like, with no restrictions.","To find the best training plan for you, you can start the <a href=\'https://offers.joinladder.com/survey?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=nav&utm_content=homepagesurvey\'>matching quiz here.</a>"]},{"title":"What if I don\'t have the suggested equipment?","details":["Your coach will recommend equipment for your program. While suggested equipment varies by program, it typically consists of free weights (dumbbells and/or kettlebell) and resistance bands.","Suggested equipment for all programs can be purchased at <a href=\'https://shop.joinladder.com/\'>The Ladder Shop</a>, which offers equipment, home gym essentials and apparel at affordable prices reserved exclusively for Ladder members.","However, if you don\'t have access to a specific piece of equipment, you can still get the most of your workouts with your bodyweight alone. Just ask your coach for modifications in the Coach Chat."]},{"title":"How long are Ladder workouts?","details":["Ladder workouts are typically 30-45 minutes in length.","Take the Ladder matching quiz to receive a personalized recommendation based on your preferred training styles and goals, including your target workout length.","Some of our training plans are specifically built for people looking for efficient workouts that are 30 minutes or less."]},{"title":"Can I supplement Ladder with other forms of training?","details":["Over 90% of Ladder members say that Ladder is the primary training program they follow. However, many Ladder members also supplement in other forms of training, like cycling and yoga and other forms of cardio workouts."]},{"title":"Are the workouts live?","details":["With Ladder, you get to save time and train on your schedule, from wherever you workout.","Ladder workouts are designed by your Coach each week and published in the Ladder app on Sunday evenings at 8:30pm ET (The Drop). Each day of the week has a specific workout for that day, with rest days built in. While workouts are designed for specific days, you can complete them in any order you’d like.","With Ladder, all you have to do is open the app and press play when it’s most convenient for you. "]},{"title":"What devices can I access Ladder on?","details":["Ladder is an iOS app and today requires an Apple mobile device like an iPhone or an iPad.","Ladder can also be casted onto any television screen that is compatible with Apple AirPlay or Screen Mirroring.","Ladder offers an integration with the Apple Watch to give you a hand’s free workout experience, however an Apple Watch is not required to use Ladder.","For members who have not upgraded to +, Ladder requires a WiFi connection. Members who upgrade to + are able to download workouts that can be played without a WiFi connection. ","Ladder is not yet available on Android devices, but we’ll be sure to let you know when it is. Join our Android <a href=\'https://airtable.com/appZ4MFpIbWACCSdi/tbltsSjRhI2bc6Lbf/viwOMt3GUOdTMFKWw?blocks=hide\'>waitlist here</a>."]},{"title":"What does a Ladder membership include?","details":["Ladder offers two membership plans that let you choose based on the features you care about most.","<b>PRO Plan, $29.99 / mo</b> <br /> Planned workout programming.",["✓ Join 1 Ladder Team","✓ Change Your Team Up to 1x Per Month","✓ 5+ New Programmed Workouts Each Week","✓ Access to Community Chats","✓ 3 Save & Replay Workouts "],"<b>ELITE Plan, $44.99 / mo</b> <br /> Planned workout programming and 1-on-1 coach help.",["✓ Everything in Pro","✓ 20 Save & Replay Workouts ","✓ Chat 1-on-1 With Your Coach","✓ 2 Form Checks Per Month  "],"Additionally, Ladder offers an upgrade for only $15 / mo that gives you unrestricted access to all Ladder workout content. Both PRO and ELITE members are eligible.",["✓ Access to All Ladder Training Teams & Workouts","✓ Unlimited Save & Replay Workouts"]]},{"title":"What is a Ladder team?","details":["Ladder offers a variety of workout programs that are led by some of the best strength coaches in the world.  Ladder workout programs or training plans are called \'teams.\'","To find the right training team for you, take the Ladder matching quiz to receive a personalized recommendation based on your training goals and preferred training styles.  Then try any (or all!) of our training teams completely free during your 7 day trial.","You can start the <a href=\'https://offers.joinladder.com/survey?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=nav&utm_content=homepagesurvey\'>matching quiz here.</a>"]},{"title":"What does the 1-on-1 coaching include?","details":["Members can use this feature to ask their coach for workout modification, equipment substitutes, and general fitness questions. With the 2 monthly Form Checks, members can upload a video of themselves performing a movement and their coach will provide feedback on their form and technique in Coach Chat.","Members on the ELITE Plan are able to chat 1-on-1 with their coach in the Coach Chat feature in the Ladder app. ","The ELITE Plan includes up to 6 1-on-1 \'Ask Your Coach\' questions per month, which includes up to 2 Form Checks per month. ","During the 7 free trial you have full access to Coach Chat, including a complimentary Form Check. "]},{"title":"Is Ladder for people who are new to working out?","details":["Anyone can try Ladder and we have members of all fitness levels.","Most Ladder members have some fitness experience and are already working out at least a few times per week prior to joining. ","Regardless of your fitness experience, you\'ll always be learning new things.","Every movement of every workout is presented as a video demonstration in the app, so you\'ll know exactly what you should be doing and what the correct form should look like. Movement videos can also be previewed for each workout prior to starting the workout.","Most movements also contain coaching cues that explain the movement and offer advice on form and proper technique. ","Each Ladder workout has been timed precisely by the coach and each movement has a timer built in to keep you on pace. ","Finally, with an ELITE Plan membership, members can ask their coach for workout modifications to make the workout easier or harder or to substitute for different equipment. ELITE Plan members can also get 1-to-1 feedback from their coach on their movement form and technique, using the Form Check feature in Coach Chat."]},{"title":"How do I cancel?","details":["You can cancel your Ladder membership at any time. Just let us know 3 business days before your next billing date to avoid the next recurring charge.","To cancel, contact Ladder Support by clicking \'Contact Support\' in the profile section of the Ladder app or emailing <a href=\'mailto:hello@joinladder.com\'>hello@joinladder.com</a>."]},{"title":"I have more questions, how can I reach Ladder?","details":["We\'d love to help! Just shoot us an email at <a href=\'mailto:hello@joinladder.com\'>hello@joinladder.com</a> and a member of our team will get back to you quickly."]}]');
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91033);
;// CONCATENATED MODULE: ./lib/use-callback-ref.js

function useCallbackRef() {
    var ref = (0,react.useState)(null), ref1 = ref[0], setRef = ref[1];
    var fn = (0,react.useCallback)(function(node) {
        setRef(node);
    }, []);
    return [
        ref1,
        fn
    ];
}

;// CONCATENATED MODULE: ./lib/use-measure.js




function useMeasure(ref) {
    var _$ref = (0,_sliced_to_array/* default */.Z)(useCallbackRef(), 2), element = _$ref[0], attachRef = _$ref[1];
    var _$ref1 = (0,react.useState)({}), bounds = _$ref1[0], setBounds = _$ref1[1];
    (0,react.useEffect)(function() {
        var onResize = function onResize(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            setBounds(entry.contentRect);
        };
        var observer = new ResizeObserver_es/* default */.Z(onResize);
        if (element && element.current) {
            observer.observe(element.current);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    (0,react.useEffect)(function() {
        attachRef(ref);
    }, [
        attachRef,
        ref
    ]);
    return bounds;
}

// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 104 modules
var react_markdown = __webpack_require__(47011);
// EXTERNAL MODULE: ./node_modules/rehype-raw/index.js + 13 modules
var rehype_raw = __webpack_require__(34768);
;// CONCATENATED MODULE: ./components/home/faq-container/index.js













function AnimateHeight(_param) {
    var duration = _param.duration, ease = _param.ease, variants = _param.variants, isVisible = _param.isVisible, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "duration",
        "ease",
        "variants",
        "isVisible",
        "children"
    ]);
    var ref = (0,react.useRef)(null);
    var bounds = useMeasure(ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "overflow-hidden",
        initial: isVisible ? "open" : "collapsed",
        animate: isVisible ? "open" : "collapsed",
        inherit: false,
        variants: variants,
        transition: {
            ease: ease,
            duration: typeof duration === "number" ? duration : getAutoHeightDuration(bounds.height) / 1000
        }
    }, other), {
        children: typeof children === "function" ? children(ref) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            children: children
        })
    }));
}
/**
 * Get the duration of the animation depending upon
 * the height provided.
 * @param {number} height of container
 */ function getAutoHeightDuration(height) {
    if (!height) return 0;
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function renderItem(item) {
    var nested = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, key = arguments.length > 2 ? arguments[2] : void 0;
    if (typeof item === "string") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
            rehypePlugins: [
                rehype_raw/* default */.Z
            ],
            className: (0,clsx_m/* default */.Z)("markdown", {
                nested: nested > 1
            }),
            children: item
        }, key);
    }
    if (Array.isArray(item)) {
        return item.map(function(n, i) {
            return renderItem(n, nested + 1, i);
        });
    }
}
var Accordion = function(param) {
    var item = param.item, i = param.i, expanded = param.expanded, setExpanded = param.setExpanded;
    var isOpen = i === expanded;
    var variants = {
        open: {
            opacity: 1,
            height: "auto"
        },
        collapsed: {
            opacity: 0,
            height: 0
        }
    };
    // By using `AnimatePresence` to mount and unmount the contents, we can animate
    // them in and out while also only rendering the contents of open accordions
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.header */.E.header, {
                initial: false,
                className: (0,clsx_m/* default */.Z)("px-4 lg:px-12 py-6 leading-normal lg:py-8 cursor-pointer lg:text-lg flex justify-between font-bold items-center uppercase bg-basic-600 text-black text-opacity-90", {
                    "rounded-lg": !isOpen,
                    "rounded-t-lg": isOpen
                }),
                onClick: function() {
                    return setExpanded(isOpen ? false : i);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        animate: {
                            rotate: isOpen ? 180 : 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {
                            style: {
                                minWidth: "1.5rem"
                            },
                            className: "w-6 h-6 text-sm min-w-6 lg:w-10 lg:h-10 text-charcoal"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimateHeight, {
                variants: variants,
                isVisible: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, {
                    className: "px-4 pb-6 space-y-4 text-lg text-black rounded-b-lg faq-details lg:px-12 lg:pb-8 bg-basic-600",
                    children: renderItem(item.details)
                })
            })
        ]
    });
};
var FaqContainer = function(param) {
    var _filter = param.filter, filter = _filter === void 0 ? [] : _filter;
    // This approach is if you only want max one section open at a time. If you want multiple
    // sections to potentially be open simultaneously, they can all be given their own `useState`.
    var ref = (0,react.useState)(), expanded = ref[0], setExpanded = ref[1];
    var data = (0,react.useMemo)(function() {
        return faq_data_namespaceObject.filter(function(param) {
            var id = param.id;
            return !filter.includes(id);
        });
    }, [
        filter
    ]);
    var ref1 = (0,react.useState)(data.slice(0, 5)), Qs = ref1[0], setQs = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full pb-32 lg:pb-56 bg-basic",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container px-4 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "mb-12 text-3xl lg:text-5xl heading",
                    children: "Still have questions?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            initial: false,
                            exitBeforeEnter: true,
                            children: Qs.map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                                    i: i,
                                    item: item,
                                    expanded: expanded,
                                    setExpanded: setExpanded
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "center",
                            children: Qs.length !== data.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "px-6 py-2 mx-auto text-lg text-center cta",
                                "aria-label": "show all FAQs",
                                onClick: function() {
                                    return setQs(data);
                                },
                                children: "Show All"
                            }) : null
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 95327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Featured; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_scrollmagic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44729);


var Featured = function() {
    // given a number between 0 and 1, get the opposit number
    var getOpposite = function(num) {
        return 1 - num;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scrollmagic__WEBPACK_IMPORTED_MODULE_1__/* .Controller */ .Q, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scrollmagic__WEBPACK_IMPORTED_MODULE_1__/* .Scene */ .x, {
            triggerHook: 1,
            duration: "100%",
            pin: false,
            children: function(progress) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    style: {
                        background: "linear-gradient(180deg, rgba(14, 14, 14, 0) 0%, #0E0E0E 25%)"
                    },
                    className: "container mt-[150px] lg:mt-[300px] relative z-40 flex flex-col items-center w-full px-6 mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            alt: "ladder logo",
                            className: "mx-auto",
                            src: "/assets/logo/big-faded.svg",
                            style: {
                                opacity: getOpposite(progress)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-8 transform -translate-y-8 lg:-translate-y-16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-sm text-center text-white heading md:text-xl lg:text-1xl",
                                    children: "FEATURED ON"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: "featured logos",
                                    className: "mx-auto lg:px-8",
                                    src: "/assets/logo/featured.svg"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};


/***/ }),

/***/ 79633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Hero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14930);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84827);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(72986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5276);
/* harmony import */ var _components_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1191);
/* harmony import */ var _components_phone_outline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15168);
/* harmony import */ var _components_text_node__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12284);
/* harmony import */ var _components_workout_player_video_player__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97685);
/* harmony import */ var _hooks_misc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74028);
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93335);
/* harmony import */ var _state_containers_app__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60208);
/* harmony import */ var _state_containers_experiment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30784);


function _templateObject() {
    var data = _tagged_template_literal([
        "perspective(1200px) translateX(0px) translateY(",
        "px) scale(",
        ") rotate(0deg) rotateX(",
        "deg) rotateY(0deg) translateZ(0px)"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var Countdown = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(function() {
    var countDown = useCountdown(60 * 30).countDown;
    return /*#__PURE__*/ _jsx("span", {
        className: "font-display center text-3xl",
        children: fancyTimeFormat(countDown)
    }, countDown);
})));
var AnimatedPhone = function(param) {
    var delay = param.delay;
    var scrollY = useViewportScroll().scrollY;
    var rotateX = useTransform(scrollY, [
        0,
        250
    ], [
        14,
        0
    ]);
    var translateY = useTransform(scrollY, [
        0,
        250
    ], [
        -24,
        0
    ]);
    var scale = useTransform(scrollY, [
        0,
        250
    ], [
        0.95,
        1
    ]);
    var isMobile = useIsMobile();
    var ref = useInView({
        threshold: 0
    }), observe = ref.observe, inView = ref.inView;
    var ref1 = _sliced_to_array(useVideo(/*#__PURE__*/ _jsx(VideoPlayer, {
        className: "absolute rounded-[40px] inset-0 object-cover w-full h-full max-w-full mx-auto sm:max-w-lg lg:max-w-lg 2xl:max-w-xl 4xl:max-w-2xl",
        controls: false,
        autoPlay: true,
        playsInline: true,
        muted: true,
        preload: "auto",
        width: "100%",
        url: "https://ladder-bootcamp-media-prod.s3.amazonaws.com/movement-videos/Lauren_Meghan/110_double_arm_continous_swing.mp4"
    })), 4), video = ref1[0], videoState = ref1[1], videoControls = ref1[2], videoRef = ref1[3];
    var transform = useMotionTemplate(_templateObject(), translateY, scale, rotateX);
    // perspective(1200px) translateX(0px) translateY(-16.6304px) scale(0.988768) rotate(0deg) rotateX(1.68478deg) rotateY(0deg) translateZ(0px)
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        transition: {
            delay: delay * 5
        },
        style: {
            transform: transform
        },
        src: "https://media.teams.joinladder.com/website/hero/phone.png",
        className: "w-full flex center max-w-[420px] xl:max-w-xl",
        children: /*#__PURE__*/ _jsxs(PhoneOutline, {
            showBrowser: false,
            height: isMobile ? 770 : 900,
            width: isMobile ? "100%" : 480,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute w-full top-0 z-10 flex center px-8 text-white",
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: 220,
                            height: 42,
                            borderRadius: "0 0 28px 28px"
                        },
                        className: "mx-auto center notch bg-neutral-900",
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                boxShadow: "0 1px 2px rgb(255 255 255 / 12%), inset 0 -0.5px 0 rgb(255 255 255 / 15%), inset 0 0 1px rgb(0 0 0), inset 0 2px 2px rgb(0 0 0 / 45%)"
                            },
                            className: "w-12 h-1 py-[.18rem] mx-auto my-1 bg-neutral-800 rounded-full"
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "w-full h-full rounded-[40px] overflow-hidden",
                    children: [
                        video,
                        /*#__PURE__*/ _jsxs("div", {
                            className: "absolute rounded-br-3xl border-b border-neutral-700 top-0 w-full pt-14 pb-3 px-4 flex items-center justify-between text-white bg-neutral-800/80 backdrop-blur-md",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "w-12 h-12 relative center",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "animate-ping absolute inline-flex h-2/3 w-2/3 duration-1000 rounded-full bg-lemon opacity-75"
                                        }),
                                        /*#__PURE__*/ _jsx("img", {
                                            className: "rounded-full relative border-lemon border",
                                            src: "https://ladderteams.imgix.net/workout-coach-avatars/Body%20%26%20Bell.png?w=100"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Countdown, {}),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-8 h-8 center",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/apple-music-icon.png"
                                    })
                                })
                            ]
                        }),
                        !isMobile ? /*#__PURE__*/ _jsx(motion.div, {
                            animate: {
                                y: !inView ? 300 : 0
                            },
                            transition: {
                                type: "spring",
                                bounce: 0.15,
                                delay: 1
                            },
                            className: "absolute rounded-tr-3xl border-t border-neutral-700 bottom-0 w-full pb-5 pt-3 px-4 flex items-center justify-end text-black bg-lemon",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col text-right",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-base font-display",
                                        children: "UP NEXT"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-sm font-medium",
                                        children: "KB Goblet Squat"
                                    })
                                ]
                            })
                        }) : null,
                        /*#__PURE__*/ _jsx("div", {
                            ref: observe,
                            className: "h-2 w-full absolute bottom-0 z-20"
                        })
                    ]
                })
            ]
        })
    });
};
var Hero = function(param) {
    var _scrollYProgessMultiplier = param.scrollYProgessMultiplier, scrollYProgessMultiplier = _scrollYProgessMultiplier === void 0 ? 1500 : _scrollYProgessMultiplier;
    var setIsHeroCTAInView = (0,_state_containers_app__WEBPACK_IMPORTED_MODULE_9__/* .useApp */ .q)().setIsHeroCTAInView;
    var variant = (0,_state_containers_experiment__WEBPACK_IMPORTED_MODULE_10__/* .useExperiment */ .a)().variant;
    var scrollYProgress = (0,framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .useViewportScroll */ .M)().scrollYProgress;
    var contentY = (0,framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .useTransform */ .H)(scrollYProgress, function(value) {
        return value / -1 * scrollYProgessMultiplier;
    });
    var observe = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        threshold: 0,
        onEnter: function() {
            setIsHeroCTAInView(true);
        },
        onLeave: function() {
            setIsHeroCTAInView(false);
        }
    }).observe;
    var isMobile = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_8__/* .useIsMobile */ .dD)();
    var marginBottom = isMobile ? 150 : 300;
    var delay = 0.25;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative w-full h-screen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.div */ .E.div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                transition: {
                    delay: delay * 5
                },
                style: {
                    height: "calc(100vh + ".concat(marginBottom, "px)"),
                    backgroundImage: "url(https://media.teams.joinladder.com/website/hero/".concat(isMobile ? "mobile/" : "").concat((0,_components_text_node__WEBPACK_IMPORTED_MODULE_5__/* .accessVariant */ .Rz)("home.hero.bg", variant), ")")
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("absolute mt-32 lg:mt-12 inset-0 z-30 w-full h-screen bg-center bg-no-repeat bg-cover")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.div */ .E.div, {
                className: "relative z-40 flex flex-col items-center justify-start h-full max-w-5xl pt-4 mx-auto lg:pt-6 xl:pt-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("relative max-w-full px-4 lg:w-52 w-36"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.img */ .E.img, {
                            initial: {
                                opacity: 0
                            },
                            animate: {
                                opacity: 1
                            },
                            transition: {
                                delay: 0.1
                            },
                            src: "/assets/apple-stars-and-reviews.svg",
                            className: "w-full mb-4",
                            alt: "womans health award"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.div */ .E.div, {
                        style: {
                            y: contentY
                        },
                        className: "relative z-10 flex flex-col items-center justify-start mx-auto transform -translate-y-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.h1 */ .E.h1, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                transition: {
                                    delay: delay * 2
                                },
                                className: "mb-4 px-4 text-2.5xl leading-8 text-center text-white uppercase lg:leading-tight md:mb-8 lg:text-5xl heading",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text_node__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                    at: "home.hero.title"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.p */ .E.p, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                transition: {
                                    delay: delay * 3
                                },
                                style: {
                                    color: "#C1C1C1"
                                },
                                className: "max-w-3xl px-6 mx-auto mb-8 text-lg text-center text-white md:mb-8 md:text-xl lg:px-20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text_node__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                                    at: "home.hero.description"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.div */ .E.div, {
                                ref: observe,
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                transition: {
                                    delay: delay * 4
                                },
                                className: "px-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_action__WEBPACK_IMPORTED_MODULE_3__/* .Action */ .a, {
                                    at: "home.hero.cta",
                                    className: "px-10 py-4 text-black rounded-full cta bg-volt"
                                })
                            }),
                            Number(variant) === 0 || [
                                "tiktok",
                                "riddler"
                            ].includes(variant) ? // <AnimatedPhone delay={delay} />
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.img */ .E.img, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                transition: {
                                    delay: delay * 5
                                },
                                src: "https://media.teams.joinladder.com/website/hero/phone.png",
                                className: "w-full max-w-lg xl:max-w-xl"
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 33005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ InEarCoachingContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5276);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23004);
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93335);







var textLine = {
    hidden: {
        opacity: 1
    },
    visible: function() {
        return {
            opacity: 1,
            transition: {
                staggerChildren: 0.04
            }
        };
    }
};
var letter = {
    hidden: {
        opacity: 0,
        y: 50
    },
    visible: {
        opacity: 1,
        y: 0
    }
};
var SplitText = function(param) {
    var text = param.text;
    return text.split("").map(function(char, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.span */ .E.span, {
            variants: letter,
            className: "",
            children: char
        }, char + "-" + index);
    });
};
var Title = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
        initial: {
            opacity: 0,
            y: 10
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true,
            amount: "all"
        },
        className: "mb-4 space-y-1 lg:mb-16 lg:ml-16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h3 */ .E.h3, {
                className: "text-lg text-black lg:text-4xl heading",
                children: "EXPERIENCE AN app built for"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h1 */ .E.h1, {
                custom: 0,
                variants: textLine,
                initial: "hidden",
                whileInView: "visible",
                viewport: {
                    once: true,
                    amount: "all"
                },
                className: "text-5xl text-black lg:text-6xl heading",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SplitText, {
                    text: "strength training"
                })
            })
        ]
    });
};
var InEarCoachingContainer = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.video */ .E.video, {
        initial: {
            opacity: 0
        },
        whileInView: {
            opacity: 1
        },
        viewport: {
            once: true,
            amount: 0.33
        },
        transition: {
            delay: 0.25
        },
        className: "max-w-full px-8 lg:px-auto lg:w-auto lg:max-w-lg",
        autoPlay: true,
        controls: false,
        loop: true,
        muted: true,
        playsInline: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                src: "https://media.teams.joinladder.com/website/wo.mov",
                type: 'video/mov; codecs="hvc1"'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                src: "https://media.teams.joinladder.com/website/videos/app/wo.webm",
                type: "video/webm"
            })
        ]
    })), 3), video = ref[0], videoState = ref[1], videoControls = ref[2];
    var ref1 = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        threshold: 0
    }), observe = ref1.observe, unobserve = ref1.unobserve, inView = ref1.inView, scrollDirection = ref1.scrollDirection, entry = ref1.entry;
    var width = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_3__/* .useWindowSize */ .iP)().width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
        ref: observe,
        className: "relative min-h-screen px-4 pb-36 lg:pb-56 center bg-basic",
        children: width < 1024 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex-col max-w-full mx-auto text-center center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative mb-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.img */ .E.img, {
                            src: "https://media.teams.joinladder.com/website/airpods/left.png",
                            className: "absolute inset-y-0 left-0 w-32 my-auto ml-auto transform -translate-x-8 translate-y-16"
                        }),
                        video,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.img */ .E.img, {
                            src: "https://media.teams.joinladder.com/website/airpods/right.png",
                            className: "absolute inset-y-0 right-0 w-32 my-auto ml-auto translate-x-8 -translate-y-8"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg",
                    style: {
                        color: "#8B8B8B"
                    },
                    children: "In-ear coaching, video demonstrations, and precise pacing built-in."
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-full px-2 mx-auto max-w-7xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "absolute left-0 z-30 w-5/6 lg:w-full lg:relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full pl-2 space-y-24 transform -translate-y-24 lg:pl-6 lg:translate-x-16",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h3 */ .E.h3, {
                                        initial: {
                                            opacity: 0,
                                            y: 10
                                        },
                                        whileInView: {
                                            opacity: 0.75,
                                            y: 0
                                        },
                                        viewport: {
                                            once: true,
                                            amount: "some"
                                        },
                                        transition: {
                                            delay: 0.25
                                        },
                                        className: "ml-8 text-2xl text-black lg:ml-24 lg:text-4xl heading",
                                        children: [
                                            "Video ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "block text-xl",
                                                children: "Demonstrations"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex self-end transform ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.img */ .E.img, {
                                        src: "https://media.teams.joinladder.com/website/airpods/left.png",
                                        className: "relative w-32 mb-8 ml-auto lg:w-48"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full transform -translate-y-8 center",
                            children: inView ? video : null
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 z-30 flex-col self-center w-2/6 translate-y-8 lg:w-full lg:relative",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full mt-24 ml-8 space-y-16",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h1 */ .E.h1, {
                                        variants: textLine,
                                        custom: 10,
                                        initial: "hidden",
                                        whileInView: "visible",
                                        viewport: {
                                            once: true,
                                            amount: "all"
                                        },
                                        className: "text-2xl text-black lg:text-6xl heading",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SplitText, {
                                            text: "In-ear Coaching"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "transform ",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.img */ .E.img, {
                                            src: "https://media.teams.joinladder.com/website/airpods/right.png",
                                            className: "relative w-32 transform -translate-x-8 lg:w-48"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h3 */ .E.h3, {
                                        initial: {
                                            opacity: 0,
                                            y: 10
                                        },
                                        whileInView: {
                                            opacity: 0.75,
                                            y: 0
                                        },
                                        viewport: {
                                            once: true,
                                            amount: "all"
                                        },
                                        className: "text-2xl text-black lg:text-4xl heading",
                                        children: [
                                            "Precise ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "block text-xl",
                                                children: "Pacing built-in"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 42899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vA": function() { return /* binding */ CommunityContainer; },
  "zN": function() { return /* binding */ FindATeam; },
  "CV": function() { return /* binding */ ForBusyPeople; },
  "Ol": function() { return /* binding */ HomeComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 116 modules
var motion = __webpack_require__(72986);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./data.json
var data = __webpack_require__(67341);
// EXTERNAL MODULE: ./lib/trackTTQEvent.js
var trackTTQEvent = __webpack_require__(52970);
// EXTERNAL MODULE: ./lib/use-breakpoint.js
var use_breakpoint = __webpack_require__(93335);
// EXTERNAL MODULE: ./components/action.js
var action = __webpack_require__(1191);
// EXTERNAL MODULE: ./components/home/app-reviews-container/index.js + 1 modules
var app_reviews_container = __webpack_require__(26165);
// EXTERNAL MODULE: ./components/home/coach-container/index.js
var coach_container = __webpack_require__(99312);
// EXTERNAL MODULE: ./components/home/every-day-section/index.js + 4 modules
var every_day_section = __webpack_require__(23572);
// EXTERNAL MODULE: ./components/home/faq-container/index.js + 3 modules
var faq_container = __webpack_require__(99141);
// EXTERNAL MODULE: ./components/home/featured.js
var featured = __webpack_require__(95327);
// EXTERNAL MODULE: ./components/home/hero/index.js
var hero = __webpack_require__(79633);
// EXTERNAL MODULE: ./components/home/in-ear-coaching-container/index.js
var in_ear_coaching_container = __webpack_require__(33005);
// EXTERNAL MODULE: ./components/text-node/index.js
var text_node = __webpack_require__(12284);
;// CONCATENATED MODULE: ./components/home/payment-teaser/index.js




var PaymentTeaser = function() {
    var isMobile = (0,use_breakpoint/* useIsMobile */.dD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative z-10 w-full pt-32 pb-32 lg:pb-56 bg-basic",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col items-center justify-center mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-full px-4 mb-16 bg-center bg-no-repeat bg-contain lg:mb-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb-12 text-4xl text-center text-black uppercase lg:mb-0 lg:text-left lg:text-6xl heading",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                                at: "home.payment.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full h-full px-2 transform bg-center bg-no-repeat bg-contain lg:-mt-16 scale-118 lg:scale-100",
                            src: "https://media.teams.joinladder.com/website/cards/".concat(isMobile ? "mobile" : "desktop", ".png"),
                            alt: "ladder app"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* Action */.a, {
                    at: "home.payment.cta",
                    className: "block px-10 py-4 mx-auto text-white bg-black rounded-full cta lg:mx-0"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/home/save-time/index.js
var save_time = __webpack_require__(7227);
;// CONCATENATED MODULE: ./components/home/shop-promo/index.js



var ShopPromo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-col px-4 pt-8 pb-8 space-y-4 text-center lg:max-w-md xl:pr-0 lg:px-8 xl:pl-16 lg:py-28 center lg:justify-start lg:items-start lg:text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "h-6",
                        src: "/assets/logo/black.svg",
                        alt: "ladder logo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-6xl text-black heading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                            at: "home.shopAd.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "pb-8 text-lg lg:pb-4 text-darkGray md:max-w-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_node/* Text */.xv, {
                            at: "home.shopAd.description"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* Action */.a, {
                        at: "home.shopAd.cta",
                        className: "px-10 py-4 text-white bg-black rounded-full cta"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "self-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://media.teams.joinladder.com/website/coaches/shop.png",
                    alt: "ladder coaches",
                    className: "w-full h-full transform scale-110 -translate-y-3 lg:scale-100 lg:-translate-y-0 lg:translate-x-8 xl:translate-x-16"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/home/training-container/index.js
var training_container = __webpack_require__(56663);
// EXTERNAL MODULE: ./components/home/video-testimonials-container/index.js
var video_testimonials_container = __webpack_require__(4858);
;// CONCATENATED MODULE: ./components/home/index.js



















var CommunityContainer = function() {
    var isMobile = (0,use_breakpoint/* useIsMobile */.dD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-basic",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col px-4 mx-auto lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center w-full px-4 mb-4 text-center xl:w-5/12 lg:w-1/2 lg:mb-16 lg:text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.h3 */.E.h3, {
                            initial: {
                                opacity: 0
                            },
                            whileInView: {
                                opacity: 1
                            },
                            viewport: {
                                once: true,
                                amount: 1
                            },
                            className: "text-lg text-black lg:text-4xl heading",
                            children: "Join a community"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.h1 */.E.h1, {
                            initial: {
                                opacity: 0
                            },
                            whileInView: {
                                opacity: 1
                            },
                            viewport: {
                                once: true,
                                amount: 1
                            },
                            className: "mt-1 text-4xl text-black lg:text-6xl heading",
                            children: "THAT SHARES YOUR PASSION"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-8 text-black lg:text-lg opacity-60",
                            children: "Start your free 7 day trial now."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: {
                                opacity: 0
                            },
                            whileInView: {
                                opacity: 1
                            },
                            viewport: {
                                once: true,
                                amount: 1
                            },
                            className: "relative center lg:justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* Action */.a, {
                                at: "home.training.cta",
                                event: {
                                    action: "find_my_plan_cta_clicked"
                                },
                                className: "px-10 py-4 mt-8 text-white bg-black rounded-full cta"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                    initial: {
                        opacity: 0
                    },
                    whileInView: {
                        opacity: 1
                    },
                    viewport: {
                        once: true,
                        amount: 0.5
                    },
                    className: "w-full h-full px-2 mt-8 transform bg-center bg-no-repeat bg-cover lg:translate-x-16 xl:w-7/12 lg:w-1/2 scale-118",
                    src: "https://media.teams.joinladder.com/website/community/".concat(isMobile ? "mobile/" : "", "main.png")
                })
            ]
        })
    });
};
var FindATeam = function() {
    var isMobile = (0,use_breakpoint/* useIsMobile */.dD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container relative px-4 pb-32 mx-auto lg:pb-56",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col lg:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-10 flex flex-col justify-center w-full max-w-xl mb-8 lg:mb-0 lg:w-5/12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-5xl mx-auto space-y-8 text-center lg:px-2 lg:text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-4xl text-white lg:text-6xl heading",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block mb-1 text-lg lg:text-4xl",
                                        children: "find a training plan"
                                    }),
                                    " ",
                                    "fit for you"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white lg:pr-12 lg:text-lg opacity-80",
                                children: "Receive a personalized recommendation based on your training goals and preferred training styles."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(action/* Action */.a, {
                                at: "home.training.cta",
                                event: {
                                    action: "find_my_plan_cta_clicked"
                                },
                                className: "px-10 py-4 text-black rounded-full cta bg-volt"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full transform translate-x-4 lg:w-7/12 lg:translate-x-24 xl:translate-x-40 2xl:translate-x-48",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "ladder coaches",
                            className: "relative z-10 w-full",
                            src: "https://media.teams.joinladder.com/website/coaches/masonry-3".concat(isMobile ? "-mobile" : "", ".png")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                background: "radial-gradient(50% 50% at 50% 50%, #403C56 28.65%, rgba(64, 60, 86, 0) 100%)"
                            },
                            className: "absolute inset-0 transform scale-110 -translate-y-24 rounded-full"
                        })
                    ]
                })
            ]
        })
    });
};
var ForBusyPeople = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container relative z-40 flex-col max-w-screen-xl px-4 pt-[150px] lg:pt-[300px] pb-24 mx-auto bg-black text-white lg:px-8 center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mb-12 text-2xl text-center lg:text-5xl heading lg:text-left",
                children: "For busy people who prioritize fitness"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 gap-6 lg:gap-8 md:grid-cols-2 lg:grid-cols-4",
                children: data.home.beni.map(function(param, i) {
                    var title = param.title, details = param.details, icon = param.icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-col px-16 text-center lg:px-0 center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: icon,
                                className: "w-12 h-12 mb-4 md:w-16 md:h-16",
                                src: "https://media.teams.joinladder.com/website/icons/".concat(icon, ".svg")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-1 text-lg text-white capitalize md:mb-2 heading",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white text-opacity-75",
                                children: details
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var HomeComponent = function() {
    (0,react.useEffect)(function() {
        (0,trackTTQEvent/* trackTTQEvent */.q)("ViewContent");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* Hero */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(featured/* Featured */.g, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForBusyPeople, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(every_day_section/* EachDaySection */.B, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(save_time/* SaveTimeContainer */.o, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(in_ear_coaching_container/* InEarCoachingContainer */._, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(training_container/* TrainingContainer */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(coach_container/* CoachContainer */.o, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindATeam, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video_testimonials_container/* VideoTestimonialsContainer */.rX, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(app_reviews_container/* AppReviewsContainer */.m, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentTeaser, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-10 w-full px-4 pb-32 lg:pb-56 lg:px-4 bg-basic",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container flex flex-col items-center mx-auto lg:justify-between lg:flex-row bg-basic-600 rounded-xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopPromo, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_container/* FaqContainer */.uw, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityContainer, {})
        ]
    });
};


/***/ }),

/***/ 7227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SaveTimeContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_text_node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12284);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var SaveTimeContainer = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative pb-36 lg:pb-56 bg-basic",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col items-center justify-center w-full px-4 mx-auto lg:space-x-8 lg:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .E.div, {
                    initial: "offscreen",
                    whileInView: "onscreen",
                    viewport: {
                        once: true,
                        amount: 0.8
                    },
                    className: "w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.img */ .E.img, {
                        variants: {
                            offscreen: {
                                y: 200,
                                opacity: 0,
                                rotate: -10
                            },
                            onscreen: {
                                y: -60,
                                opacity: 1,
                                rotate: 0,
                                transition: {
                                    type: "spring",
                                    bounce: 0.2,
                                    duration: 0.8
                                }
                            }
                        },
                        src: "https://media.teams.joinladder.com/website/watch/group.png",
                        className: "max-w-full w-lg md:max-w-lg"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full max-w-xl space-y-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "text-5xl text-center text-black uppercase lg:text-left lg:text-6xl heading",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "block text-lg lg:text-4xl",
                                    children: "Save time & train"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "block",
                                    children: "on your schedule"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "px-6 text-lg text-center lg:text-xl lg:text-left text-charcoal lg:pr-20 lg:pl-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text_node__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                at: "home.watch.description"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 56663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrainingContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5276);
/* harmony import */ var _components_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1191);
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93335);






var MockCoachMessage = function(param) {
    var image = param.image, from = param.from, date = param.date, message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-64 space-x-2 text-white md:w-80",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "items-start center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: "w-16 rounded-full md:w-24",
                    src: "/assets/coaches/".concat(image),
                    alt: "ladder coach ".concat(image)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-start space-x-2 center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-sm capitalize text-shadow-sm md:text-base heading",
                                children: from
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-xs text-shadow-sm",
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        // style={{ backgroundColor: "#575757" }}
                        className: "p-4 text-xs text-white rounded-lg text-shadow-sm md:text-base bg-messageGray bg-opacity-60 backdrop-blur-lg",
                        children: message
                    })
                ]
            })
        ]
    });
};
var MockMemberMessage = function(param) {
    var image = param.image, from = param.from, date = param.date, message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-64 ml-auto space-x-2 text-white md:w-80",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-end space-x-2 center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-sm capitalize text-shadow-sm md:text-base heading",
                                children: from
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-xs text-shadow-sm",
                                children: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            background: "linear-gradient(96.42deg, rgba(255, 255, 255, 0.75) 67.84%, rgba(242, 255, 119, 0.75) 123.79%)"
                        },
                        className: "p-4 text-xs text-black rounded-lg md:text-base bg-messageGray bg-opacity-60 backdrop-blur-lg",
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "items-start center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: "w-16 rounded-full md:w-24",
                    src: "https://media.teams.joinladder.com/website/coaches/chat/".concat(image),
                    alt: "ladder member ".concat(image)
                })
            })
        ]
    });
};
var AnimateIn = function(param) {
    var children = param.children;
    var ref = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        threshold: 1,
        onEnter: function(param) {
            var observe = param.observe, unobserve = param.unobserve;
            unobserve();
        }
    }), observe = ref.observe, unobserve = ref.unobserve, inView = ref.inView, scrollDirection = ref.scrollDirection, entry = ref.entry;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.div */ .E.div, {
        ref: observe,
        initial: "hidden",
        animate: inView ? "visible" : "hidden",
        variants: {
            hidden: {
                opacity: 0,
                y: 100
            },
            visible: {
                opacity: 1,
                y: 0,
                delay: 1
            }
        },
        className: "relative",
        children: children
    });
};
var TrainingContainer = function() {
    var breakpoint = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpoint */ .Gc)();
    var isMobile = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_4__/* .useIsMobile */ .dD)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            maxHeight: "1100px"
        },
        className: "relative z-20 lg:z-10 lg:h-screen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    maxHeight: "1100px",
                    minHeight: "680px",
                    backgroundImage: "url(https://media.teams.joinladder.com/website/phone/in-hand".concat(isMobile ? "-mobile" : "", ".png)"),
                    height: [
                        "sm",
                        "md"
                    ].includes(breakpoint) ? "calc(100vh - 240px)" : ""
                },
                className: "bottom-0 left-0 z-20 w-full max-w-2xl mx-auto transform -translate-y-12 bg-center bg-no-repeat bg-cover md:h-screen lg:bg-center-bottom md:bg-contain lg:max-w-4xl lg:-translate-x-16 lg:absolute lg:w-2/3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative z-40 flex flex-col w-full h-full pt-16 pl-4 pr-4 space-y-12 transform md:justify-center lg:pb-36 xl:pb-48 lg:pl-24 xl:pl-36 md:pl-12 lg:pr-16 md:space-y-16 lg:translate-x-16",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimateIn, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MockCoachMessage, {
                                        image: "neen.png",
                                        from: "Coach Neen",
                                        date: "Today @ 3:24 pm",
                                        message: "Nice job! To help avoid hurting yourself, can you send me a video of your form?"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimateIn, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MockMemberMessage, {
                                        image: "member.png",
                                        from: "Me",
                                        date: "Today @ 3:31 pm",
                                        message: "Feeling strong and efficient. Here’s the complex for today’s workout!"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AnimateIn, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MockCoachMessage, {
                                        image: "neen.png",
                                        from: "Coach Neen",
                                        date: "Today @ 3:45 pm",
                                        message: "Boom! Make sure you keep your feet shoulder width apart. Explode with your hips!"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            background: "linear-gradient(180deg, rgba(14, 14, 14, 0) 24.63%, #0E0E0E 71.23%)"
                        },
                        className: "absolute bottom-0 z-30 w-full h-48"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container relative flex flex-col-reverse items-center justify-center h-full px-2 mx-auto -mt-24 lg:mt-0 lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full lg:w-2/3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full mb-24 space-y-8 lg:w-1/3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: "text-5xl text-center text-white uppercase lg:text-6xl lg:text-left heading",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-lg lg:text-4xl",
                                        children: "Learn from"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    " the best"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "px-6 text-lg text-center text-white opacity-60 lg:text-left lg:pr-20 lg:pl-0",
                                children: "Answers to all your questions, and 1-on-1 help from your coach when you need it."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex mt-10 center lg:block lg:mt-110",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_action__WEBPACK_IMPORTED_MODULE_3__/* .Action */ .a, {
                                    at: "home.training.cta",
                                    className: "block px-10 py-4 mx-auto text-black rounded-full cta bg-volt lg:mx-0"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 15168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ PhoneOutline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63801);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62469);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56554);





var PhoneOutline = function(param) {
    var children = param.children, _id = param.id, id = _id === void 0 ? "phone-outline" : _id, _showBrowser = param.showBrowser, showBrowser = _showBrowser === void 0 ? true : _showBrowser, _height = param.height, height = _height === void 0 ? 850 : _height, _width = param.width, width = _width === void 0 ? 420 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: id,
        style: {
            maxHeight: height,
            minHeight: height,
            width: width,
            minWidth: width,
            boxShadow: "rgb(255 255 255 / 87%) 0px 0px 2px 0px, rgb(0 0 0 / 99%) 0px 0px 10px 0px"
        },
        className: "w-full h-full relative max-w-md m-0 overflow-hidden scale-90 bg-black border-4 shadow-xl iphone border-neutral-900",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    maxHeight: showBrowser ? 712 : "none",
                    minHeight: 712
                },
                className: "w-full h-full overflow-x-hidden overflow-y-scroll",
                children: children
            }),
            showBrowser ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sticky bottom-0 z-20 w-full p-2 bg-neutral-800",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between px-3 py-2 text-white bg-black rounded-xl",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "aA"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "gap-1 select-all center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .LockClosedIcon */ .khe, {
                                        className: "w-3 h-3 text-neutral-300"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            _helpers_misc__WEBPACK_IMPORTED_MODULE_4__/* .isDev */ .r8 ? "dev." : "",
                                            "joinladder.com"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .RefreshIcon */ .DuK, {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between px-3 py-4 pb-4 text-white/60",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ChevronLeftIcon */ .wyc, {
                                className: "w-8 h-8"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ChevronRightIcon */ .XCv, {
                                className: "w-8 h-8"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .Share2Icon */ .eA8, {
                                className: "w-7 h-7"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .BookmarkIcon */ .plf, {
                                className: "w-7 h-7"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .CopyIcon */ .TIy, {
                                className: "w-7 h-7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-36 h-1 py-[.18rem] mx-auto my-1 bg-white/90 rounded-full"
                    })
                ]
            }) : null
        ]
    });
};


/***/ }),

/***/ 74028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useCountdown; },
/* harmony export */   "p": function() { return /* binding */ useIOSSafeHeight; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11042);


function useCountdown(duration, onEnd) {
    var end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(duration), countDown = ref[0], setCountDown = ref[1];
    var interval = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        interval.current = setInterval(function() {
            setCountDown(function(current) {
                return current - 1;
            });
        }, 1000);
        return function() {
            return clearInterval(interval.current);
        };
    }, [
        onEnd
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (countDown !== end) return;
        if (typeof onEnd === "function") return onEnd();
        setCountDown(duration);
    }, [
        duration,
        countDown,
        onEnd,
        end
    ]);
    return {
        countDown: countDown
    };
}
var useIOSSafeHeight = function() {
    (0,react_use__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        if (false) {}
        document.documentElement.style.setProperty("--vh", window.innerHeight * 0.01 + "px");
    }, []);
    return "calc(var(--vh, 1vh) * 100)";
};


/***/ })

}]);